import React from 'react';
import { ProductDetailBase } from './product-detail-base';

export default ({ pageContext }) => <ProductDetailBase ctx={pageContext} />;
